import 'react-popper-tooltip/dist/styles.css';
import 'nouislider/distribute/nouislider.css';
import 'rc-collapse/assets/index.css';
import 'aos/dist/aos.css';
import 'assets/styles/global.css';

import { GTM_ID } from '@lib/constants/APP_CONFIG';
import Script from 'next/script';
import { AppProps } from 'next/app';
import { PersistGate } from 'redux-persist/integration/react';
import { Provider } from 'react-redux';
import { useStore } from '@lib/state/store';
import { persistStore } from 'redux-persist';
import { useRouter } from 'next/router';
import { useCurrency } from '@lib/view/hooks/curency';
import Head from '@lib/view/components/Head';
import ConversionTracking from '@lib/view/components/ConversionTracking';
import SpinnerLoading from '@components/loading/spinner-loading';

const ComponentWithState: React.FC = () => {
    useCurrency();
    return null;
};

const LoadingComponent: React.FC<React.PropsWithChildren<{}>> = ({
    children,
}) => {
    const { pathname } = useRouter();
    if (pathname === '/') {
        return <div>{children}</div>;
    }
    return <SpinnerLoading />;
};

const AnimationComponent: React.FC<React.PropsWithChildren<{}>> = ({
    children,
}) => {
    return <div className="translate-loading">{children}</div>;
};

const App: React.FC<AppProps> = ({ Component, pageProps }) => {
    const store = useStore(pageProps.initialReduxState);
    const persistor = persistStore(store, {}, (): void => {
        persistor.persist();
    });

    const { title, description, image } = pageProps;
    return (
        <>
            <Head title={title} description={description} image={image} />
            {/* <!-- Google Tag Manager --> */}
            <Script
                id="google-tag"
                dangerouslySetInnerHTML={{
                    __html: `
                    (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
                    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
                    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
                    'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
                    })(window,document,'script','dataLayer','${GTM_ID}');`,
                }}
            />
            {/* <!-- End Google Tag Manager --> */}
            <Provider store={store}>
                <PersistGate
                    loading={
                        <LoadingComponent>
                            <Component {...pageProps} />
                        </LoadingComponent>
                    }
                    persistor={persistor}
                >
                    <AnimationComponent>
                        <Component {...pageProps} />
                    </AnimationComponent>
                    <ComponentWithState />
                    <ConversionTracking />
                </PersistGate>
            </Provider>
        </>
    );
};

export default App;
